import { useSyncExternalStore } from "react";
import { timeAgo } from "@helpers/date";

const TICK_INTERVAL_MS = 60_000;

const listeners = new Set<() => void>();
let tickIntervalId: ReturnType<typeof setInterval> | undefined;

function notifyListeners(): void {
    listeners.forEach((listener) => listener());
}

function handleVisibilityChange(): void {
    if (document.visibilityState === "visible") {
        notifyListeners();
    }
}

export function subscribeToMinuteTick(listener: () => void): () => void {
    if (listeners.size === 0) {
        tickIntervalId = setInterval(notifyListeners, TICK_INTERVAL_MS);
        document.addEventListener("visibilitychange", handleVisibilityChange);
    }
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
        if (listeners.size === 0) {
            clearInterval(tickIntervalId);
            document.removeEventListener(
                "visibilitychange",
                handleVisibilityChange,
            );
        }
    };
}

export function useTimeAgo(date: Date): string {
    return useSyncExternalStore(subscribeToMinuteTick, () => timeAgo(date));
}
